// extracted by mini-css-extract-plugin
export default {"container":"SocietyAdmin_container__U9YcM"};